export default class DateUtils {
  static now = new Date();
  static CurrentDayINMillisecondsUTC = Date.UTC(
    DateUtils.now.getUTCFullYear(),
    DateUtils.now.getUTCMonth(),
    DateUtils.now.getUTCDate(),
    DateUtils.now.getUTCHours(),
    DateUtils.now.getUTCMinutes(),
    DateUtils.now.getUTCSeconds(),
    DateUtils.now.getUTCMilliseconds()
  );
  static CurrentDayInMilliseconds = new Date(new Date().setHours(0, 0, 0, 0)).getTime();

  static ConvertHoursToSplitTime(numberOfHours: number): {
    hours: number;
    minutes: number;
    days: number;
  } {
    const days = Math.floor(numberOfHours / 24);
    const remainder = numberOfHours % 24;
    const hours = Math.floor(remainder);
    const minutes = Math.floor(60 * (remainder - hours));

    return { days, hours, minutes };
  }

  static DiscardTimezone(d: Date): string {
    return d.toISOString().split('.')[0];
  }

  static HoursToMilliseconds(hours: number): number {
    return hours * 60 * 60 * 1000;
  }

  static MillisecondsToSeconds(millis: number): number {
    return +(millis / 1000).toFixed(0);
  }
}
